export const neutralColors = {
  neutral100: '#02315B',
  utilityGrey: '#313638',
  utilityWhite: '#FFF',
} as const;
